import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('unlock', true, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48"
  }, [_createVNode("g", {
    "stroke": "none",
    "stroke-width": props.strokeWidth,
    "fill": "none",
    "fill-rule": "evenodd"
  }, [_createVNode("g", null, [_createVNode("rect", {
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "fill": props.colors[1],
    "fill-rule": "nonzero",
    "stroke-linejoin": props.strokeLinejoin,
    "x": "7",
    "y": "22.047619",
    "width": "34",
    "height": "22"
  }, null), _createVNode("path", {
    "d": "M14,22 L14,14.004718 C13.9947898,8.87021688 17.9227159,4.56718073 23.0858694,4.05116974 C28.2490229,3.53515876 32.9673301,6.97408127 34,12.0058975",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null), _createVNode("path", {
    "d": "M24,30 L24,36",
    "stroke": props.colors[2],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap,
    "stroke-linejoin": props.strokeLinejoin
  }, null)])])]);
});